var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHairDryer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.833 4L4.66801 6.86125C4.43465 6.90029 4.22269 7.02081 4.0698 7.20138C3.91692 7.38196 3.83302 7.6109 3.83301 7.8475V14.1525C3.83302 14.3891 3.91692 14.618 4.0698 14.7986C4.22269 14.9792 4.43465 15.0997 4.66801 15.1388L21.833 18C23.6895 18 25.47 17.2625 26.7828 15.9497C28.0955 14.637 28.833 12.8565 28.833 11C28.833 9.14348 28.0955 7.36301 26.7828 6.05025C25.47 4.7375 23.6895 4 21.833 4ZM21.833 14C21.2397 14 20.6596 13.8241 20.1663 13.4944C19.673 13.1648 19.2884 12.6962 19.0614 12.1481C18.8343 11.5999 18.7749 10.9967 18.8907 10.4147C19.0064 9.83279 19.2921 9.29824 19.7117 8.87868C20.1312 8.45912 20.6658 8.1734 21.2477 8.05764C21.8297 7.94189 22.4329 8.0013 22.9811 8.22836C23.5292 8.45542 23.9978 8.83994 24.3274 9.33329C24.6571 9.82664 24.833 10.4067 24.833 11C24.833 11.7956 24.5169 12.5587 23.9543 13.1213C23.3917 13.6839 22.6287 14 21.833 14Z",
    fill: "#E85D04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 14C23.4899 14 24.833 12.6569 24.833 11C24.833 9.34315 23.4899 8 21.833 8C20.1762 8 18.833 9.34315 18.833 11C18.833 12.6569 20.1762 14 21.833 14Z",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 14.1525V7.8475C3.83302 7.6109 3.91692 7.38196 4.0698 7.20138C4.22269 7.02081 4.43465 6.90029 4.66801 6.86125L21.833 4C23.6895 4 25.47 4.7375 26.7828 6.05025C28.0955 7.36301 28.833 9.14348 28.833 11C28.833 12.8565 28.0955 14.637 26.7828 15.9497C25.47 17.2625 23.6895 18 21.833 18L4.66801 15.1388C4.43465 15.0997 4.22269 14.9792 4.0698 14.7986C3.91692 14.618 3.83302 14.3891 3.83301 14.1525Z",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 26V27C19.833 28.0609 20.2544 29.0783 21.0046 29.8284C21.7547 30.5786 22.7721 31 23.833 31H25.833",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1443 16.515L22.0993 25.4138C22.0198 25.5885 21.8918 25.7367 21.7304 25.8407C21.5691 25.9446 21.3812 25.9999 21.1893 26H18.833C18.5678 26 18.3134 25.8947 18.1259 25.7071C17.9384 25.5196 17.833 25.2652 17.833 25V17.3338",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairDryer);
export default __webpack_public_path__ + "static/media/HairDryer.1f69bc517745b5672bc1d60774de0897.svg";
export { ForwardRef as ReactComponent };